module.exports = __webpack_public_path__ + "static/media/tiny-web-stacks.80d35f38.png";